import HomeButton from "./components/HomeButton";
import ChapterSelection from "./components/ChapterSelection";
import Recorder from "./components/Recorder";
import clsx from 'clsx';
import MenuImg from "./img/menu.png";
import CloseImg from "./img/close.png";
import useMenu from "./useMenu";

import './menu.css';

const Menu = ({
  currentPageName,
  setTranscription,
  chapterComplete,
  setChapterComplete,
  chapterStart,
  onResetPages,
  testMode,
  onOpenChapterSelection,
}) => {
  const { showMenu, isMenuRetract, handleOnReset, toggleMenu } = useMenu({
    currentPageName,
    chapterComplete,
    setChapterComplete,
    onResetPages,
  });

  return (
    <div className={clsx('menu-overlay', {
      'menu-overlay--show': showMenu,
    })}>
      <div className="menu">
        <button
          className="menu-button"
          onClick={toggleMenu}
          aria-label={isMenuRetract ? "Abrir menu" : "Fechar menu"}
        >
          {isMenuRetract ? (
            <img src={MenuImg} className="menu-img" alt="" />
          ) : (
            <img src={CloseImg} className="menu-img" alt="" />
          )}
        </button>
        <HomeButton
          onResetPages={handleOnReset}
          disableBtn={!showMenu}
          isMenuRetract={isMenuRetract}
        />
        <ChapterSelection
          disableBtn={!showMenu}
          isMenuRetract={isMenuRetract}
          onClick={onOpenChapterSelection}
        />
        {!testMode && (<Recorder
          currentPageName={currentPageName}
          setTranscription={setTranscription}
          chapterComplete={chapterComplete}
          chapterStart={chapterStart}
          disableBtn={!showMenu}
          isMenuRetract={isMenuRetract}
        />)}
      </div>
    </div>

  )
}

export default Menu;